import {
	OrganizationalNodeModel,
	OrganizationalUnitService } from '../../customers/organizational-units/organizational-unit-service';
import { NodeModel } from '../../../models/node-model';
import { bindable, autoinject, observable } from 'aurelia-framework';
import { ServiceStructureService } from '../../services/service-structure-service';
import { IRowGeneratorParameters } from '../models/report-template';
import { SideBar } from '../../../components/side-bar/side-bar';

@autoinject
export class RowGeneratorIdentifiers {
	@bindable customerId: string;
	@bindable parameters: IRowGeneratorParameters;
	@bindable generator: string;
	@bindable selectedIdentifiersChanged: (params: { identifiers: string[] }) => void;

	organizationNodes: OrganizationalNodeModel[];
	serviceStructureNodes: NodeModel[];
	@observable identifiers: string[];

	private originalIdentifiers: string[];

	resetIdentifiers = (() => {
		this.identifiers = this.originalIdentifiers.slice();
	}).bind(this);

	constructor(
		private serviceStructureService: ServiceStructureService,
		private organizationalUnitService: OrganizationalUnitService,
		private sideBar: SideBar) {
	}

	async attached() {
		await this.ensureServiceStructureAvailability();
		await this.ensureOrganizationAvailability();
		this.identifiers = this.parameters.identifiers.slice();
		this.originalIdentifiers = this.parameters.identifiers.slice();
		this.sideBar.addCloseEventListener(this.resetIdentifiers);
	}

	detached() {
		this.sideBar.removeCloseEventListener(this.resetIdentifiers);
	}

	updateIdentifiers(values: string[]) {
		this.identifiers = values;
		this.selectedIdentifiersChanged({ identifiers: this.identifiers.slice() });
	}

	private async ensureServiceStructureAvailability() {
		if (this.generator === 'ServiceStructure' && !this.serviceStructureNodes) {
			this.serviceStructureNodes =
				await this.serviceStructureService.getServiceStructureForCustomer(this.parameters.serviceStructureId, this.customerId);
		}
	}

	private async ensureOrganizationAvailability() {
		if (this.generator === 'Organizational' && !this.organizationNodes) {
			this.organizationNodes =
				await this.organizationalUnitService.getOrganizationalUnits(this.parameters.organizationId, false);
		}
	}
}
